export default __webpack_public_path__ + "static/purpleBack-6df16120a8c04158b520e4844a8f384a.jpg";